/**
 * CaseExpensesPage - Standalone page for case expense management
 */

import { useState } from 'react';
import { useParams } from 'react-router-dom';

import type { ReadCaseExpense } from '@/services/api/generated/caseExpensesService';

import { CaseExpenseFormDialog } from './CaseExpenseFormDialog';
import { CaseExpensesTable } from './CaseExpensesTable';

export const CaseExpensesPage = () => {
  const { matter_id } = useParams<{ matter_id: string }>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [expenseToEdit, setExpenseToEdit] = useState<
    ReadCaseExpense | undefined
  >();

  if (!matter_id) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-red-600 font-medium">Matter ID not found</p>
      </div>
    );
  }

  const handleAddExpense = () => {
    setExpenseToEdit(undefined);
    setDialogOpen(true);
  };

  const handleEditExpense = (expense: ReadCaseExpense) => {
    setExpenseToEdit(expense);
    setDialogOpen(true);
  };

  const handleCloseDialog = (open: boolean) => {
    if (!open) {
      setDialogOpen(false);
      setExpenseToEdit(undefined);
    }
  };

  return (
    <div className="bg-white">
      <div className="max-w-[1400px] mx-auto px-6 py-3">
        <CaseExpensesTable
          matterId={matter_id}
          onEditExpense={handleEditExpense}
          onAddExpense={handleAddExpense}
        />
      </div>

      <CaseExpenseFormDialog
        matterId={matter_id}
        expense={expenseToEdit}
        open={dialogOpen}
        onOpenChange={handleCloseDialog}
      />
    </div>
  );
};
